export default __webpack_public_path__ + "static/media/logs.c748fd45.md";